import { render } from "./CourseHeader.vue?vue&type=template&id=3708beaa&scoped=true&ts=true"
import script from "./CourseHeader.vue?vue&type=script&lang=ts"
export * from "./CourseHeader.vue?vue&type=script&lang=ts"

import "./CourseHeader.vue?vue&type=style&index=0&id=3708beaa&lang=postcss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3708beaa"]])

export default __exports__